module.exports = __webpack_public_path__ + "afb265ce9a731dec.svg";